$(window).on("scroll", function() {
    var sticky = $("#header-sticky"),
        scroll = $(window).scrollTop();

    if (scroll >= 260) {
        sticky.addClass("fixed");
        $('body').css({marginTop: `${sticky.outerHeight()}px`});
    } else {
        sticky.removeClass("fixed");
        $('body').removeAttr('style');
    }
});
